module.exports = __webpack_public_path__ + "img/ext-01.d5b0ad71.jpg";